var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckboxCheckedActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.731a.656.656 0 01-.393.295.656.656 0 01-.488-.058l-4.433-2.459a.913.913 0 01-.342-1.277l.326-.544a.992.992 0 011.323-.355l2.768 1.535 4.403-7.33a.993.993 0 011.323-.355l.555.308c.46.255.613.828.342 1.278l-5.383 8.962z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconCheckboxCheckedActive;